<!-- Agent Selector - Sidebar navigation matching chat-sessions panel -->
<div class="agent-panel-total">
  <div class="agent-panel-history" id="agent-panel">
    
    <!-- Header: Collapse Menu Button -->
    <div class="header-actions">
      <button 
        (click)="onCollapseMenu()"
        class="panel-collapse-btn hover-effect-text t-right t-no-arrow"
        id="agent-panel-collapse-button"
        aria-label="Collapse sidebar menu">
        <img src="../../../../../assets/images/newchat/icon-toggle-button.svg" alt="Collapse">
        {{'COLLAPSE_MENU_BUTTON'| translate}}
      </button>
    </div>

    <!-- Agents Section -->
    <div class="agents-section">
      <div class="section-title">{{'LANDING_PAGE_H1'| translate}}</div>
      
      <!-- Loading State -->
      <div *ngIf="isLoading" class="loading-state">
        <span class="loading-spinner"></span>
      </div>

      <!-- Agent List -->
      <ul class="agent-list" *ngIf="!isLoading">
        <li 
          *ngFor="let agent of agents"
          class="agent-item"
          [class.active]="isAgentActive(agent)"
          (click)="onAgentClick(agent)"
          (keydown)="onAgentItemKeydown($event, agent)"
          role="button"
          tabindex="0"
          [attr.aria-label]="'Select ' + agent.name"
          [attr.aria-pressed]="isAgentActive(agent)">
          <img 
            [src]="getAgentIcon(agent)" 
            [alt]="agent.name + ' icon'"
            class="agent-icon"
            (error)="$any($event.target).src = 'assets/images/agents/default-agent.svg'">
          <span class="agent-name">{{ (agent.name || "")| translate }}</span>
        </li>
      </ul>

      <!-- All Agents Option -->
       <span class="all-agents-section"> 
      <button
        class="all-agents-btn"
        [class.active]="isAllAgentsActive()"
        (click)="onAllAgentsClick()"
        aria-label="View all agents">
        <span class="all-agents-icon">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="6" cy="12" r="2" fill="currentColor"/>
            <circle cx="12" cy="12" r="2" fill="currentColor"/>
            <circle cx="18" cy="12" r="2" fill="currentColor"/>
          </svg>
        </span>
        <span>{{ 'CHAT_HISTORY_ALL_AGENTS' | translate }}</span>
      </button>
      </span>

      <!-- AI Hub  -->
      <div class="ai-hub-section" *ngIf="workbenchAccessAllowed">
        <div class="ai-hub-heading">{{ 'AI_HUB_TITLE' | translate }}</div>
        <button
          type="button"
          class="ai-workbench-btn"
          [class.active]="isAiWorkbenchActive()"
          (click)="onAiWorkbenchClick()"
          aria-label="AI Workbench">
          <span class="ai-workbench-icon" aria-hidden="true">
            <img
              src="../../../../../assets/images/workbench/workbench.svg"
              width="24"
              height="24"
              alt="">
          </span>
          <span>{{ 'AI_WORKBENCH_TITLE' | translate }}</span>
        </button>
      </div>
    </div>

  </div>
</div>
